import React from 'react'
import { Outlet } from 'react-router-dom'













const classes = {}

export default function PageLayout() {

  return (
    <React.Fragment>
      <Outlet />
    </React.Fragment>
  )

}